import { useEffect, useLayoutEffect, useState } from 'react';

import { CHALLENGER_BREAKPOINTS } from '../media';

const isSSR = typeof window === 'undefined';
const useIsomorphicLayoutEffect = isSSR ? useEffect : useLayoutEffect;

const classifyWidth = (width: number) => ({
  isMobile: width <= CHALLENGER_BREAKPOINTS.mobileMaxPx,
  isTablet:
    width >= CHALLENGER_BREAKPOINTS.tabletMinPx &&
    width <= CHALLENGER_BREAKPOINTS.tabletMaxPx,
  isDesktop: width >= CHALLENGER_BREAKPOINTS.desktopMinPx,
});

/**
 * Challenger breakpoints (1280 / 768 / mobile).
 *
 * First render always uses the desktop classifier so SSR markup and the
 * initial client render match; the layout effect then applies `innerWidth`.
 */
export function useChallengerBreakpoints() {
  const [classifier, setClassifier] = useState(() =>
    classifyWidth(CHALLENGER_BREAKPOINTS.desktopMinPx),
  );

  useIsomorphicLayoutEffect(() => {
    const onResize = () => {
      setClassifier((prev) => {
        const next = classifyWidth(window.innerWidth);
        return prev.isMobile === next.isMobile &&
          prev.isTablet === next.isTablet &&
          prev.isDesktop === next.isDesktop
          ? prev
          : next;
      });
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return classifier;
}
